import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const createEventInterest = (payload) => {
    return vdkEmHappinessPortalApi.post('/vdk-event-interests/create', payload);
};
const updateEventInterest = (payload) => {
    return vdkEmHappinessPortalApi.put('/vdk-event-interests/update', payload);
};
const deleteEventInterest = (id) => {
    return vdkEmHappinessPortalApi.delete(`/vdk-event-interests/${id}`);
};
const getEventInterestById = (id) => {
    return vdkEmHappinessPortalApi.get(`/vdk-event-interests/${id}`);
};
const getEventInterestsByEventId = (payload) => {
    return vdkEmHappinessPortalApi.post('/eventinterests/get-all', payload);
};
const EventInterestsApi = {
    createEventInterest,
    updateEventInterest,
    deleteEventInterest,
    getEventInterestById,
    getEventInterestsByEventId
};
export default EventInterestsApi;
